// extracted by mini-css-extract-plugin
module.exports = {"Title":"Share__Title_j0a4K"};